import { useMemo, useState } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
//@ts-expect-error ts-migrate
import { ModalIFrame } from 'ui-addon-iframeable/host/ModalIFrame';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DemoPortalCardAction = ({
  fromObjectId
}) => {
  const [isModalOpen, setModalOpenStatus] = useState(false);
  const toggleModalOpenStatus = () => {
    setModalOpenStatus(status => !status);
  };
  const onClose = () => {
    setModalOpenStatus(false);
  };
  const srcUrl = useMemo(() => {
    return `${getFullUrl('tools', {
      domainOverride: 'hubteam'
    })}/demospot-embedded-ui/create-demo`;
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "transparent",
      size: "extra-small",
      onClick: toggleModalOpenStatus,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flywheel.FlywheelDemoPortalCard.Action.title"
      })
    }), /*#__PURE__*/_jsx(ModalIFrame, {
      show: isModalOpen,
      height: "800",
      width: "600",
      onClose: onClose,
      onError: onClose,
      src: srcUrl,
      embeddedPassthruProps: {
        dealId: fromObjectId
      }
    })]
  });
};